module.exports = __webpack_public_path__ + "img/index_bg.995d15f0.png";